exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-text[data-v-5b0e6232]{color:#fff}", ""]);

// exports
